"use client";

import React from "react";
import { FaQuoteLeft, FaStar } from "react-icons/fa";
import Container from "../Container";

const testimonials = [
    {
        quote: "Peerquik cut my development time from months to days! The Buyer/Seller auth and Stripe integration were seamless, and the admin panel is a game-changer for managing my marketplace.",
        name: "Alex Rivera",
        role: "Indie Developer",
        avatar: "/images/avatars/alex.png", // Placeholder; replace with real image
    },
    {
        quote: "As a CTO, I needed a robust C2C platform fast. Peerquik’s TypeScript codebase and /app router gave us a scalable foundation, saving us $20,000+ in dev costs.",
        name: "Priya Sharma",
        role: "Startup CTO",
        avatar: "/images/avatars/priya.png", // Placeholder; replace with real image
    },
    {
        quote: "I launched my Airbnb-inspired app in a week with Peerquik. The docs, UI components, and Coolify deployment made it so easy, even as a solo freelancer!",
        name: "Liam Chen",
        role: "Freelancer",
        avatar: "/images/avatars/liam.png", // Placeholder; replace with real image
    },
];

const Testimonials = () => {
    return (
        <section className="py-20 bg-black text-white">
            <Container>
                <h2 className="text-3xl md:text-4xl font-bold text-center mb-12">
                    Why Devs Love Peerquik for B2C & P2P Marketplaces
                </h2>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                    {testimonials.map((testimonial, index) => (
                        <div
                            key={index}
                            className="border-t-4 border-cyan-400 bg-gray-800 text-gray-800 p-6 rounded-xl shadow-md hover:shadow-lg transform hover:scale-105 transition-all duration-300"
                        >
                            <FaQuoteLeft className="text-cyan-400 text-2xl mb-4" />
                            <p className="text-white mb-4 leading-relaxed">
                                {testimonial.quote}
                            </p>
                            <div className="flex items-center mb-4">
                                <div className="flex text-yellow-400">
                                    {[...Array(5)].map((_, i) => (
                                        <FaStar key={i} className="w-5 h-5" />
                                    ))}
                                </div>
                            </div>
                            <div className="flex items-center">
                                <img
                                    src={testimonial.avatar}
                                    alt={testimonial.name}
                                    className="w-12 h-12 rounded-full mr-4 object-cover"
                                />
                                <div>
                                    <p className="font-semibold text-white">
                                        {testimonial.name}
                                    </p>
                                    <p className="text-sm text-gray-300">{testimonial.role}</p>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
                <div className="mt-12 flex justify-center items-center gap-6">
                    <a title="ai tools code.market" href="https://code.market?code.market=verified"><img alt="ai tools code.market" title="ai tools code.market" src="https://code.market/assets/manage-product/featured-logo-dark.svg" /></a>
                    <a href="https://twelve.tools" target="_blank"><img src="https://twelve.tools/badge0-dark.svg" alt="Featured on Twelve Tools" width="200" height="54" /></a>
                </div>
            </Container>
        </section>
    );
};

export default Testimonials;